import { render, staticRenderFns } from "./channelSelecter.vue?vue&type=template&id=6c50a563&scoped=true&"
import script from "./channelSelecter.vue?vue&type=script&lang=js&"
export * from "./channelSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50a563",
  null
  
)

export default component.exports